import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  standalone: false,
  templateUrl: './privacy-policy.html',
  styleUrls: ['../legal.css']
})
export class PrivacyPolicy {
  lastUpdated = 'December 6, 2025';
}
